import { useCallback, useMemo } from "react";
import { useLocation } from "react-router";
import { NavigateOptions, useNavigate } from "react-router-dom";


export const useRouteHandler = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const moveToAgentList = useCallback((options?: NavigateOptions) => {
        navigate("/agents", options);
    }, [navigate]);

    const moveToDashboard = useCallback((agentId: number, options?: NavigateOptions) => {
        navigate(`/agents/${agentId}/dashboard`, options);
    }, [navigate]);

    const moveToIntent = useCallback((agentId: number, options?: NavigateOptions) => {
        navigate(`/agents/${agentId}/intent`, options);
    }, [navigate]);

    const moveToEntity = useCallback((agentId: number, options?: NavigateOptions) => {
        navigate(`/agents/${agentId}/entity`, options);
    }, [navigate]);

    const moveToEntityValue = useCallback((agentId: number, entityId: string, options?: NavigateOptions) => {
        navigate(`/agents/${agentId}/entity/${entityId}`, options);
    }, [navigate]);

    const moveToDeployment = useCallback((agentId: number, options?: NavigateOptions) => {
        navigate(`/agents/${agentId}/deploy`, options);
    }, [navigate]);

    const moveToAutocompleteList = useCallback((agentId: number, options?: NavigateOptions) => {
        navigate(`/agents/${agentId}/autocomplete`, options);
    }, [navigate]);

    const moveToAutocompleteKeyword = useCallback((agentId: number, autocompleteId: string, options?: NavigateOptions) => {
        navigate(`/agents/${agentId}/autocomplete/${autocompleteId}`, options);
    }, [navigate]);

    const moveToBulkTestList = useCallback((agentId: number, options?: NavigateOptions) => {
        navigate(`/agents/${agentId}/test`, options);
    }, [navigate]);

    const moveToBulkTestResult = useCallback((agentId: number, testId: string, options?: NavigateOptions) => {
        navigate(`/agents/${agentId}/test/${testId}`, options);
    }, [navigate]);

    const removeStateKey = useCallback((key: string) => {
        const { [key]: _, ...rest } = location.state;
        navigate(location.pathname, { state: rest, replace: true });
    }, [location, navigate]);

    const resetRoute = useCallback( () => {
        moveToAgentList({ replace: true });
    }, [moveToAgentList]);

    return useMemo(() => {
        return {
            moveToAgentList,
            moveToDashboard,
            moveToIntent,
            moveToEntity,
            moveToEntityValue,
            moveToAutocompleteList,
            moveToAutocompleteKeyword,
            moveToBulkTestList,
            moveToBulkTestResult,
            moveToDeployment,
            removeStateKey,
            resetRoute
        };
    }, [
        moveToAgentList,
        moveToDashboard,
        moveToIntent,
        moveToEntity,
        moveToEntityValue,
        moveToAutocompleteList,
        moveToAutocompleteKeyword,
        moveToBulkTestList,
        moveToBulkTestResult,
        moveToDeployment,
        removeStateKey,
        resetRoute
    ]);
};
